import { MediaItem } from '../types';

/**
 * Check if project has segmented video
 */
export const isProjectSegmented = (project: any): boolean => {
  return project?.isVideoSegmented === true;
};

/**
 * Filter and sort video segments from MediaItems
 */
export const filterVideoSegments = (mediaItems: MediaItem[]): MediaItem[] => {
  return mediaItems
    .filter(item => item.type === 'video')
    .sort((a, b) => a.start - b.start);
};

/**
 * Get total segment count
 */
export const getSegmentCount = (mediaItems: MediaItem[]): number => {
  return filterVideoSegments(mediaItems).length;
};

/**
 * Check if MediaItem is a video segment (part of segmented video)
 */
export const isVideoSegment = (mediaItem: MediaItem, project: any): boolean => {
  return isProjectSegmented(project) && mediaItem.type === 'video';
};

/**
 * Get segment display info
 */
export const getSegmentInfo = (
  segment: MediaItem,
  allSegments: MediaItem[]
): {
  segmentNumber: number;
  totalSegments: number;
  displayName: string;
} => {
  const segmentNumber = allSegments.findIndex(s => s.id === segment.id) + 1;
  const totalSegments = allSegments.length;
  const displayName = segment.name || `Segment ${segmentNumber}`;

  return {
    segmentNumber,
    totalSegments,
    displayName,
  };
};
